var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns columns--full is-vcentered onboarding-create-site__step2"},[_c('div',{staticClass:"column has-text-centered onboarding-create-site__description"},[(_vm.content.step1.answer)?_c('h1',{staticClass:"onboarding-create-site__title",domProps:{"innerHTML":_vm._s(_vm.content.step1.answer.answer)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }